import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.57533 5.70808C7.44253 7 7.27344 9.19503 7.27344 11.9951C7.27344 14.7962 7.44267 16.9918 7.57548 18.2836C8.75213 17.7557 10.7258 16.8083 13.1702 15.397C15.6137 13.9862 17.4206 12.7512 18.4662 11.996C17.4101 11.2336 15.5888 9.98709 13.1713 8.59135C10.7538 7.19561 8.76363 6.24145 7.57533 5.70808ZM5.6687 4.76014C5.78733 3.7806 6.8035 3.1955 7.70997 3.58321C8.77077 4.03692 11.1511 5.11558 14.1713 6.8593C17.1922 8.60342 19.3168 10.1258 20.2397 10.8173C21.0281 11.4081 21.0304 12.5803 20.2412 13.1729C19.3267 13.8596 17.2278 15.3637 14.1702 17.129C11.1116 18.8948 8.75895 19.9606 7.70758 20.409C6.80085 20.7957 5.78738 20.2095 5.66894 19.232C5.5306 18.0902 5.27344 15.4973 5.27344 11.9951C5.27344 8.49488 5.5303 5.90299 5.6687 4.76014Z"
	})
});
export default SvgPlayLine;
